// StrumentiProva.tsx — /prova: gli strumenti per i tester (account segnati dal pannello, con prova.attiva accesa).
// Partita contro il bot, laboratorio di tutti i filtri, quota azzerata, numeri del rilevamento in partita, video solo
// via TURN, domanda dell'età di nuovo. Testi dello spazio "admin" (strumenti interni, italiano e inglese).
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAccount } from "../servizi/account.ts";
import { azzeraQuota, creaPartitaProva, impostaOpzioneProva, opzioneProva } from "../servizi/prova.ts";
import { salvaToken } from "../servizi/sfide.ts";
import { leggiPreferenza, salvaPreferenza } from "../servizi/preferenze.ts";
import { vai } from "../servizi/percorso.ts";
import { caricaAdmin } from "../i18n/index.ts";
import { ErroreRete } from "../servizi/api.ts";
import { PERCORSO_GRUPPO, PERCORSO_SFIDA, PERCORSO_TORNEO, PREFERENZE } from "../costanti.ts";
import { creaTorneo, salvaTokenTorneo } from "../servizi/tornei.ts";
import { creaGruppo, salvaTokenGruppo } from "../servizi/gruppi.ts";
import { Laboratorio } from "./Laboratorio.tsx";

export function StrumentiProva() {
  const { t } = useTranslation("admin");
  const account = useAccount();
  const [pronto, setPronto] = useState(false);
  const [laboratorio, setLaboratorio] = useState(false);
  const [messaggio, setMessaggio] = useState<string | null>(null);
  const [opzioni, setOpzioni] = useState(() => ({ diag: opzioneProva(PREFERENZE.provaDiagnostica), turn: opzioneProva(PREFERENZE.provaSoloTurn) }));
  useEffect(() => {
    void caricaAdmin().then(() => setPronto(true));
  }, []);
  if (!pronto || account.tipo === "caricamento") return <p aria-busy="true" className="pagina">…</p>;
  if (account.tipo !== "registrato" || !account.io.tester)
    return (
      <div className="pagina schermata-semplice">
        <p className="schermata-testo" role="alert">
          {t("prova.non_tester")}
        </p>
        <button type="button" className="pulsante pulsante-secondario" onClick={() => vai("/")}>
          {t("gioco.torna_home", { ns: "app" })}
        </button>
      </div>
    );
  const errore = (e: unknown) => setMessaggio(t("prova.errore", { codice: e instanceof ErroreRete ? e.codice : String(e) }));

  return (
    <div className="pagina strumenti-prova">
      <h1 className="invito-titolo">{t("prova.titolo")}</h1>
      <p className="nota">{t("prova.spiegazione")}</p>
      {laboratorio ? (
        <Laboratorio onChiudi={() => setLaboratorio(false)} />
      ) : (
        <div className="azioni-colonna">
          <button
            type="button"
            className="pulsante pulsante-primario pulsante-grande"
            onClick={() =>
              creaPartitaProva(account.io.nome)
                .then((r) => {
                  salvaToken(r.codice, r.token);
                  vai(`${PERCORSO_SFIDA}${r.codice}`);
                })
                .catch(errore)
            }
          >
            {t("prova.partita_bot")}
          </button>
          <p className="nota">{t("prova.partita_bot_nota")}</p>
          {/* v039: torneo a eliminazione e partita a 4 con i bot */}
          <button
            type="button"
            className="pulsante pulsante-secondario"
            onClick={() =>
              creaTorneo(account.io.nome, true)
                .then((r) => {
                  salvaTokenTorneo(r.codice, r.token);
                  vai(`${PERCORSO_TORNEO}${r.codice}`);
                })
                .catch(errore)
            }
          >
            {t("prova.torneo_bot")}
          </button>
          <p className="nota">{t("prova.torneo_bot_nota")}</p>
          <button
            type="button"
            className="pulsante pulsante-secondario"
            onClick={() =>
              creaGruppo(account.io.nome, true)
                .then((r) => {
                  salvaTokenGruppo(r.codice, r.token);
                  vai(`${PERCORSO_GRUPPO}${r.codice}`);
                })
                .catch(errore)
            }
          >
            {t("prova.gruppo_bot")}
          </button>
          <p className="nota">{t("prova.gruppo_bot_nota")}</p>
          <button type="button" className="pulsante pulsante-secondario" onClick={() => setLaboratorio(true)}>
            {t("prova.laboratorio")}
          </button>
          <button
            type="button"
            className="pulsante pulsante-secondario"
            onClick={() =>
              azzeraQuota()
                .then(() => setMessaggio(t("prova.quota_azzerata")))
                .catch(errore)
            }
          >
            {t("prova.azzera_quota")}
          </button>
          <label className="interruttore">
            <input
              type="checkbox"
              checked={opzioni.diag}
              onChange={(e) => {
                impostaOpzioneProva(PREFERENZE.provaDiagnostica, e.target.checked);
                setOpzioni((o) => ({ ...o, diag: e.target.checked }));
              }}
            />
            <span>{t("prova.diagnostica")}</span>
          </label>
          <label className="interruttore">
            <input
              type="checkbox"
              checked={opzioni.turn}
              onChange={(e) => {
                impostaOpzioneProva(PREFERENZE.provaSoloTurn, e.target.checked);
                setOpzioni((o) => ({ ...o, turn: e.target.checked }));
              }}
            />
            <span>{t("prova.solo_turn")}</span>
          </label>
          <button
            type="button"
            className="pulsante pulsante-piccolo"
            onClick={() => {
              // La prossima apertura richiede di nuovo la data di nascita (prova della schermata dell'età).
              const prima = leggiPreferenza(PREFERENZE.nascita);
              if (prima) salvaPreferenza(PREFERENZE.nascita, "");
              location.assign("/");
            }}
          >
            {t("prova.rifai_eta")}
          </button>
          {messaggio && (
            <p className="nota" role="status">
              {messaggio}
            </p>
          )}
          <button type="button" className="pulsante pulsante-secondario" onClick={() => vai("/")}>
            {t("gioco.torna_home", { ns: "app" })}
          </button>
        </div>
      )}
    </div>
  );
}
